export default __webpack_public_path__ + "static/media/toddler-1923.555ff164.bmp";